var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.59 8.82c.216.24.604.24.82 0l4.456-4.955c.305-.338.055-.865-.41-.865H1.544c-.465 0-.715.527-.41.865z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNS41OSA4LjgyYy4yMTYuMjQuNjA0LjI0LjgyIDBsNC40NTYtNC45NTVjLjMwNS0uMzM4LjA1NS0uODY1LS40MS0uODY1SDEuNTQ0Yy0uNDY1IDAtLjcxNS41MjctLjQxLjg2NXoiLz48L3N2Zz4=";
export { SvgSorted as ReactComponent };